import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CircleCheckIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 1C7.76113 1 1 7.76113 1 16C1 24.2389 7.76113 31 16 31C24.2389 31 31 24.2389 31 16C31 7.76113 24.2389 1 16 1ZM14.1847 22.8227L7.61605 16.2541L10.1017 13.7684L14.2997 17.9664L22.7274 10.3052L25.0929 12.9058L14.1847 22.8227Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
